import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import StepByStepCreateCampaignBannerData from "./StepByStepCreateCampaignBannerData";

export default function StepByStepCreateCampaignBanner() {
  const generateStepTags = () => {
    return StepByStepCreateCampaignBannerData.map((step) => {
      return (
        <>
          <div>
            <div className="py-2 step-title">
              <span className="p-2 rounded">{step.title}</span>
            </div>
            <div className="py-3">
              <p className="m-0">{step.description}</p>
            </div>
            <div className="py-3">
              <div className="h_iframe-aparat_embed_frame">
                <span className="d-block" style={{ paddingTop: "57%" }}></span>
                <iframe
                  src={step.iframe_src}
                  allowfullscreen={true}
                  webkitallowfullscreen={true}
                  mozallowfullscreen={true}
                ></iframe>
              </div>
            </div>
            <div className="text-center py-3">
              <a
                href={step.link_PDF_file}
                target="_blank"
                className="btn btn-success ml-2"
              >
                دانلود فایل PDF
              </a>
              <a
                href={step.link_web_page}
                target="_blank"
                className="btn btn-success"
              >
                صفحه آموزش
              </a>
            </div>
          </div>
          <hr />
        </>
      );
    });
  };
  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="راهنمای گام به گام تبلیغات بنری موضوعی" />

        <section
          className="content pt-5"
          id="step-by-step-create-campaign-banner-container"
        >
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link className="btn btn-primary" to="/help">
                  <span>بازگشت</span>
                  <span class="pr-2">
                    <i class="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>

              {generateStepTags()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
